import { useQuery } from "@tanstack/react-query";
import { getSnoozedAlerts } from "../../../api/alertsApi";
import { AlertItem } from "../../../pages/Alerts/alertsMockData";

export const SNOOZED_ALERTS_QUERY_KEY = ["alerts", "snoozed"];

export const useSnoozedAlerts = () => {
  const { data, isLoading } = useQuery<AlertItem[]>(SNOOZED_ALERTS_QUERY_KEY, getSnoozedAlerts);
  return { alerts: data ?? [], isLoading };
};
